import type { ScreenerMetricValues } from '../../components/PageConfigProvider/types/metric';

/**
 * Returns the start_val for each screener metric in order to include all records.
 */
export const getScreenerSegmentStartValue = (
  metric: ScreenerMetricValues
): number => {
  switch (metric) {
    case 'screener_headcount':
      return 0;
    case 'screener_growth':
      return -1;
    case 'screener_growth_yoy':
      return -1;
    case 'screener_hiring':
      return 0;
    case 'screener_attrition':
      return 0;
    case 'screener_salary':
      return 0;
    case 'screener_tenure':
      return 0;
    case 'screener_inflow':
      return 0;
    case 'screener_outflow':
      return 0;
    default:
      return 0;
  }
};
